import React, { FunctionComponent, SVGAttributes } from 'react';
import { Svg } from '../../SvgOptimizer/Svg';

const Sharp: FunctionComponent<SVGAttributes<SVGSVGElement>> = (props) => (
  <Svg optimizationId="iconsContentCopySharp" viewBox="0 0 24 24" {...props}>
    <path d="M16 1H2v16h2V3h12z" />
    <path d="M21 5v18H6V5z" />
  </Svg>
);

Sharp.displayName = 'ContentCopySharp';

export default Sharp;
